module.exports = __webpack_public_path__ + "static/media/pic2.9caf32f6.jpg";